import React from 'react'
import './styles/module3PA.scss'

function Module3PA(props){
  let{module,redirect} = props
  if(redirect){
    window.location.href=module.url;
  }
  return(<React.Fragment/>)
}
export default Module3PA
